import React from 'react'
import { useTranslation } from 'react-i18next'

import { VStack } from '~/components/elements/VStack'

import { indicatorGroups, indicatorLabelI18nKeyMap } from '../../utils'

import { InPageLink } from './InPageLink'
import { LinkGroup } from './LinkGroup'

export const TimeSeriesAnalysisNavigation = () => {
  const { t } = useTranslation()

  return (
    <VStack spacing={8} verticalAppearance="stretch-scroll">
      <InPageLink
        indicator="distribution"
        label={t(indicatorLabelI18nKeyMap['distribution'])}
      />

      {indicatorGroups.map((indicatorGroup) => (
        <LinkGroup key={indicatorGroup} indicatorGroup={indicatorGroup} />
      ))}
    </VStack>
  )
}
